<script lang="ts" setup>
import { computed, ref, useAttrs, watch } from 'vue';

import { injectRowContext, injectTableContext } from './model';

const { isRowSelected, isRowSelectable, isZebra, isSmall } = injectTableContext();
const { key, index, measureElement } = injectRowContext();

const attrs = useAttrs();

const rowRef = ref<HTMLTableRowElement>();

const ariaSelected = computed<boolean | undefined>(() => {
  if (!isRowSelectable(key.value)) return undefined;

  return isRowSelected(key.value);
});

watch(rowRef, (ref) => measureElement?.(ref ?? null), { immediate: true });
</script>
<template>
  <tr
    ref="rowRef"
    class="group/row relative z-0"
    :class="{
      'cursor-pointer': attrs.onClick !== undefined,
      'bg-gray-50 dark:bg-navy-900/90': isZebra && index % 2 === 0,
      'dark:bg-navy-900/40': isZebra && index % 2 === 1,
      'h-[40px]': isSmall,
      'h-[45px]': !isSmall,
    }"
    :aria-rowindex="index + 1"
    :aria-selected="ariaSelected"
    :data-index="index"
  >
    <slot></slot>
  </tr>
</template>
